/**
 * The controls of the options (the title screen's Options, the match's pause menu): volumes, mute, the team name.
 * Every change is kept at once (options.ts) and heard (sound.ts).
 */
import { loadOptions, saveOptions } from './options';
import { sound } from './sound';
import { DEFAULT_TEAM_NAMES, MAX_TEAM_NAME } from './teams';

const LABELS = { volume: 'Volume', music: 'Music', effects: 'Sound effects' } as const;

export function buildOptionsPanel(box: HTMLElement, withName: boolean): void {
  const o = loadOptions();
  box.innerHTML = `
    ${(['volume', 'music', 'effects'] as const).map((k) => `<label>${LABELS[k]} <span><input data-o="${k}" type="range" min="0" max="100" value="${Math.round(o[k] * 100)}" /> <b data-o="${k}-out">${Math.round(o[k] * 100)}</b></span></label>`).join('')}
    <label class="check"><input data-o="muted" type="checkbox" ${o.muted ? 'checked' : ''} /> Mute</label>
    ${withName ? `<label>Team name <input data-o="name" type="text" maxlength="${MAX_TEAM_NAME}" placeholder="${DEFAULT_TEAM_NAMES[0]}" /></label>` : ''}`;
  const get = <T extends HTMLElement>(k: string) => box.querySelector(`[data-o="${k}"]`) as T;
  for (const k of ['volume', 'music', 'effects'] as const) {
    const slider = get<HTMLInputElement>(k);
    slider.oninput = () => { get(`${k}-out`).textContent = slider.value; sound.setLevel(k, Number(slider.value) / 100); };
    slider.onchange = () => sound.click();
  }
  const muted = get<HTMLInputElement>('muted');
  muted.onchange = () => { sound.setMuted(muted.checked); sound.click(); };
  if (withName) {
    const name = get<HTMLInputElement>('name');
    name.value = o.teamName;
    name.oninput = () => { saveOptions({ teamName: name.value.trim().slice(0, MAX_TEAM_NAME) }); };
  }
}
